var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"options":_vm.states,"track-by":"key","label":"value","multiple":false,"allowEmpty":true,"placeholder":"Estado","selectedLabel":"","selectLabel":"","deselectLabel":""},on:{"input":_vm.notifyChange},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }